import { memo } from "react";
import SplitLayout from "@core/layout/SplitLayout";
import WesentlichkeitAccordion from "@services/components/wesentlichkeit/WesentlichkeitAccordion";
import WesentlichkeitTreeView from "@services/components/wesentlichkeit/WesentlichkeitTreeView";

const WesentlichkeitPage = memo(() => {
    return <SplitLayout containerLeft={<WesentlichkeitTreeView />} containerRight={<WesentlichkeitAccordion />} />;
});

export default WesentlichkeitPage;
